<template>
    <div>
        <h4 class="cursus-register__form-title mb-3">Adresse de facturation</h4>

        <div class="card">
            <div class="card-body">
                <template v-if="edit">
                    <div class="mb-n3">
                        <Field v-model="value.name" name="invoice_address.name" label="Nom" :errors="errors" />
                        <Field
                            v-model="value.organization_service"
                            name="invoice_address.organization_service"
                            label="Service (si applicable)"
                            :errors="errors"
                        />

                        <AddressForm
                            :value="value"
                            :errors="errors"
                            :show-comment="false"
                            :show-phone="false"
                            name="invoice_address"
                            @input="handleInput"
                        />
                    </div>
                </template>
                <template v-else>
                    <div class="row align-items-center">
                        <div class="col">
                            <AddressLabel :address="value" />
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-link" @click="handleEditClicked">
                                Modifier...
                            </button>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import AddressForm from "../../../addresses/AddressForm";
    import Field from "../../../Field";
    import AddressLabel from "../../../addresses/AddressLabel";

    export default {
        components: {
            AddressLabel,
            Field,
            AddressForm
        },
        props: {
            value: Object,
            errors: Object,
        },
        data() {
            return {
                edit: false,
            }
        },
        methods: {
            handleInput(address) {
                this.$emit('input', address);
            },
            handleEditClicked() {
                this.edit = true;
            },
        }
    }
</script>
